module.exports = __webpack_public_path__ + "img/icon3.e1561975.svg";